import * as main from './../../../mozgiel/assets/js/main.js'
import * as custom from './../../../mozgiel/assets/js/custom.js'
import * as counter from './../../../mozgiel/assets/js/counter.js'
import * as hamburger from './../../../mozgiel/assets/js/hamburger.js'
import * as parallax from './../../../mozgiel/assets/js/parallax.js'
import * as offcanvas from './../../../mozgiel/assets/js/offcanvas.js'
import * as bodyscroll from './../../../mozgiel/assets/js/bodyscroll.js'

/**
 * Add child theme functionality here
 */
(function ($) {

    $(document).ready(function () {
        new WOW().init();
    });

})( jQuery );